/**
 * Remueve los logs de consola en el entorno de producción
 */
export const removeDebugLogs = ()=>{
	if (process.env.NODE_ENV === "production") {
		console.log = function () { };
		console.info = function () { };
        console.debug = function () { };
        console.trace = function () { };
	}
}